<div class="container contentHeight">
    <div class="row lonelyStuff mx-auto d-flex justify-content-center actions">
        <!-- Action 1 Add Material-->
        <div class="col-lg-4 col-md-6 mt-3 box action">
            <div routerLink="/adminlacourLicence" class="cardAction backgroundWhiteRound">
                <div class="text-dark text-center textAction">
                    <i class="fal fa-file-certificate fa-3x" aria-hidden="true"></i>
                    <p>Gestion des achats licences</p>
                </div>
            </div>
        </div>
        <!-- Action 1 Add Material-->
        <div class="col-lg-4 col-md-6 mt-3 box action">
            <div routerLink="/adminlacourCommande" class="cardAction backgroundWhiteRound">
                <div class="text-dark text-center textAction">
                    <i class="fal fa-hand-holding-box fa-3x" aria-hidden="true"></i>
                    <p>Gestion des commandes</p>
                </div>
            </div>
        </div>
        <!-- Action 1 Add Material-->
        <div class="col-lg-4 col-md-6 mt-3 box action">
            <div routerLink="/adminlacourRenting" class="cardAction backgroundWhiteRound">
                <div class="text-dark text-center textAction">
                    <i class="fal fa-handshake fa-3x" aria-hidden="true"></i>
                    <!-- <i class="fal fa-people-carry fa-3x" aria-hidden="true"></i> -->
                    <!-- <i class="fal fa-hand-receiving fa-3x" aria-hidden="true"></i> -->
                    <p>Gestion location de terminaux</p>
                </div>
            </div>
        </div>
        <!-- Action 1 Add Material-->
        <div class="col-lg-4 col-md-6 mt-3 box action">
            <div routerLink="/listproducts" class="cardAction backgroundWhiteRound">
                <div class="text-dark text-center textAction">
                    <i class="fal fa-box-full fa-3x" aria-hidden="true"></i>
                    <p>Gestion des<br /> produits</p>
                </div>
            </div>
        </div>
        <!-- Action 1 Add Material-->
        <div class="col-lg-4 col-md-6 mt-3 box action">
            <div routerLink="/localaccounthistory" class="cardAction backgroundWhiteRound">
                <div class="text-dark text-center textAction">
                    <i class="fal fa-history fa-3x" aria-hidden="true"></i>
                    <p>Historique des comptes clients </p>
                </div>
            </div>
        </div>
        <!-- Action 1 Add Material-->
        <div class="col-lg-4 col-md-6 mt-3 box action">
            <div routerLink="/renaultmail" class="cardAction backgroundWhiteRound">
                <div class="text-dark text-center textAction">
                    <i class="fal fa-mail-bulk fa-3x" aria-hidden="true"></i>
                    <p>Mails RT pour comptes clients</p>
                </div>
            </div>
        </div>
    </div>
</div>
